<template>
  <div class="mobile-nav" role="navigation" aria-label="Hauptnavigation mobil">
    <div class="nav">
      <button class="nav-link" :class="{ active: activePage === 'home' }" @click="handleNavigate('home')"
        title="Zur Startseite" type="button">
        <span class="material-icons-outlined" aria-hidden="true">cottage</span>
        <span>Start</span>
      </button>

      <button class="nav-link" :class="{ active: activePage === 'orte', expanded: openPanel === 'orte' }"
        @click="openSheet('orte')" title="Einrichtungen anzeigen" type="button">
        <span class="material-icons-outlined" aria-hidden="true">place</span>
        <span>Einrichtungen</span>
      </button>

      <button class="nav-link" :class="{ active: activePage === 'angebote', expanded: openPanel === 'angebote' }"
        @click="openSheet('angebote')" title="Angebote anzeigen" type="button">
        <span class="material-icons-outlined" aria-hidden="true">calendar_today</span>
        <span>Angebote</span>
      </button>

      <button class="nav-link" :class="{ active: activePage === 'infos', expanded: openPanel === 'infos' }"
        @click="openSheet('infos')" title="Infos anzeigen" type="button">
        <span class="material-icons-outlined" aria-hidden="true">info</span>
        <span>Infos</span>
      </button>

      <button class="nav-link" :class="{ active: activePage === 'mehr', expanded: openPanel === 'mehr' }"
        @click="openSheet('mehr')" title="Weitere Links" type="button">
        <span class="material-icons-outlined" aria-hidden="true">more_vert</span>
        <span>Mehr</span>
      </button>
    </div>

    <transition name="slide-up">
      <div v-if="openPanel" class="sheet" role="dialog" aria-modal="true">
        <div class="sheet__header">
          <button v-if="activeCategory && openPanel === 'angebote'" class="sheet__back" @click="activeCategory = null"
            aria-label="Zurück" type="button">
            <span class="material-icons-outlined" aria-hidden="true">arrow_back</span>
          </button>
          <div class="sheet__title" :class="activeAccentClass">
            <template v-if="openPanel === 'angebote'">
              {{ activeCategory ? activeCategory.title : 'Angebote' }}
            </template>
            <template v-else-if="openPanel === 'orte'">
              Einrichtungen
            </template>
            <template v-else>
              Infos
            </template>
          </div>
          <button class="sheet__close" @click="closeSheet" aria-label="Schließen" type="button">
            <span class="material-icons-outlined" aria-hidden="true">close</span>
          </button>
        </div>

        <div class="sheet__body">
          <template v-if="openPanel === 'angebote'">
            <div v-if="activeCategory" class="sheet-list">
              <button v-for="item in activeCategory.items" :key="item.label"
                class="sheet-list__item sheet-list__item--plain" @click="navigateToCategory(item, activeCategory)"
                type="button">
                <span>{{ item.label }}</span>
              </button>
            </div>
            <div v-else class="sheet-list">
              <button v-for="category in angebotCategories" :key="category.title" class="sheet-list__item"
                @click="activeCategory = category" type="button">
                <div class="sheet-list__meta">
                  <img :src="category.icon" :alt="category.title" class="sheet-icon" />
                  <span :class="['sheet-list__title', category.colorClass]">{{ category.title }}</span>
                </div>
              </button>
            </div>
          </template>

          <template v-else-if="openPanel === 'orte'">
            <div class="sheet-list">
              <button v-for="category in mainCategories" :key="category.title" class="sheet-list__item"
                @click="navigateTo(category.to)" type="button">
                <div class="sheet-list__meta">
                  <span :class="['dot', category.colorClass]" aria-hidden="true"></span>
                  <span class="sheet-list__title">{{ category.title }}</span>
                </div>
              </button>
            </div>
          </template>

          <template v-else-if="openPanel === 'infos'">
            <div class="sheet-list">
              <button v-for="info in infoLinks" :key="info.title" class="sheet-list__item" @click="navigateTo(info.to)"
                type="button">
                <div class="sheet-list__meta">
                  <img :src="info.icon" :alt="info.title" class="sheet-icon" />
                  <span class="sheet-list__title">{{ info.title }}</span>
                </div>
              </button>
            </div>
          </template>

          <template v-else-if="openPanel === 'mehr'">
            <div class="sheet-list">
              <button v-for="link in moreLinksComputed" :key="link.id"
                :class="['sheet-list__item', link.separator ? 'sheet-list__item--sep' : '', link.type === 'action' ? 'sheet-list__item--plain' : '']"
                @click="navigateMore(link)" type="button">
                <div class="sheet-list__meta">
                  <img v-if="link.iconType === 'img'" :src="link.icon" :alt="link.title" class="sheet-icon" />
                  <span v-else class="material-icons-outlined sheet-icon" aria-hidden="true">{{ link.icon }}</span>
                  <span class="sheet-list__title">{{ link.title }}</span>
                </div>
              </button>
            </div>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Resource from '@/api/resource';
import { getStructuredFilters } from '@/utils/helpers';

export default {
  name: 'MobileNav',
  data() {
    return {
      openPanel: null,
      activeCategory: null,
      ctOrte: null,
      ctAngebote: null,
      infoLinks: [
        {
          title: 'Ratgeber',
          to: { name: 'Guide' },
          icon: '/assets/icons/ratgeber.png',
        },
        {
          title: 'Merklisten',
          to: { name: 'Merkliste' },
          icon: '/assets/icons/merklisten.png',
        },
        {
          title: 'Kita- & Schulfinder',
          to: { name: 'BildungsFinder' },
          icon: '/assets/icons/Schulfinder.png',
        },
      ],
      moreLinks: [
        {
          id: 'nutzungsbedingungen',
          title: 'Nutzungsbedingungen',
          icon: 'description',
          iconType: 'material',
          to: { name: 'Nutzungsbedingungen' },
        },
        {
          id: 'datenschutz',
          title: 'Datenschutz',
          icon: 'shield',
          iconType: 'material',
          to: { name: 'Datenschutz' },
        },
        {
          id: 'dgs',
          title: 'Gebärdensprache',
          icon: '/assets/dgs_symbol_black.png',
          iconType: 'img',
          to: '/system/1811920',
        },
        {
          id: 'barrierefrei',
          title: 'Barrierefreiheitserklärung',
          icon: 'accessibility_new',
          iconType: 'material',
          to: { name: 'Barrierefreiheitserklaerung' },
        },
        {
          id: 'impressum',
          title: 'Impressum',
          icon: 'person',
          iconType: 'material',
          to: { name: 'Impressum' },
        },
        {
          id: 'anbietende',
          title: 'Login für Anbietende',
          icon: 'open_in_new',
          iconType: 'material',
          external: 'https://cms.wolfsburgerlupe.de/#/',
        },
      ],
    };
  },
  created() {
    this.fetchContentTypes();
  },
  computed: {
    route() {
      return this.$route.path;
    },
    activePage() {
      if (this.openPanel) return this.openPanel;
      if (this.$route.path === '/') return 'home';
      if (this.$route.path.includes('orte')) return 'orte';
      if (this.$route.path.includes('angebote') || this.$route.path.includes('category')) return 'angebote';
      if (this.$route.path.includes('ratgeber') || this.$route.path.includes('merkliste')) return 'infos';
      if (this.$route.path.includes('mehr')) return 'mehr';
      return '';
    },
    userLoggedIn() {
      return !!(this.$store && this.$store.getters && this.$store.getters.getToken);
    },
    moreLinksComputed() {
      const links = [...this.moreLinks];
      if (this.userLoggedIn && !this.$hideUserAccountRelatedFunctions) {
        links.splice(4, 0, {
          id: 'profile',
          title: 'Mein Profil',
          icon: '/assets/logo/WOLFSBURGER LUPE-Icon.svg',
          to: { name: 'Profile' },
        });
        links.push({
          id: 'logout',
          title: 'Abmelden',
          icon: '/assets/logo/WOLFSBURGER LUPE-Icon.svg',
          type: 'action',
          onClick: () => {
            this.$store.dispatch('logout');
            this.$router.push({ name: 'Home' });
            this.closeSheet();
          },
        });
      } else if (!this.$hideUserAccountRelatedFunctions) {
        links.splice(4, 0, {
          id: 'login',
          title: 'Login',
          icon: '/assets/logo/WOLFSBURGER LUPE-Icon.svg',
          to: { name: 'Login' },
        });
      }
      return links;
    },
    mainCategories() {
      const palette = ['dot--magenta', 'dot--yellow', 'dot--teal', 'dot--orange'];
      const filters = getStructuredFilters(this.ctOrte);
      if (!filters || !filters.length || !filters[0].options) return [];
      const fieldTypeId = filters[0].field_type_id;

      const categoryDotStyles = {
        'Beratung & Hilfe': 'dot--magenta',
        'Beratung und Hilfe': 'dot--magenta',
        Freizeit: 'dot--yellow',
        'Aus- & Weiterbildung': 'dot--teal',
        'Ausbildung & Weiterbildung': 'dot--teal',
        'Kita- & Schulfinder': 'dot--orange',
      };

      return filters[0].options.map((opt, idx) => {
        const filterValue = opt.label || opt.value;
        const filterArray = [[fieldTypeId, [filterValue]]];
        const filtersParam = encodeURIComponent(JSON.stringify(filterArray));
        const colorClass = categoryDotStyles[filterValue] || palette[idx % palette.length];

        return {
          title: filterValue,
          to: `/orte?filters=${filtersParam}`,
          colorClass,
        };
      });
    },
    angebotCategories() {
      const palette = ['accent--magenta', 'accent--yellow', 'accent--teal', 'accent--orange'];
      const icons = [
        '/assets/icons/beruf.png',
        '/assets/icons/hilfe.png',
        '/assets/icons/freizeit.png',
        '/assets/icons/kita.png',
      ];
      const categoryStyles = {
        'Beratung & Hilfe': {
          colorClass: 'accent--magenta',
          icon: '/assets/icons/hilfe.png',
        },
        'Beratung und Hilfe': {
          colorClass: 'accent--magenta',
          icon: '/assets/icons/hilfe.png',
        },
        Freizeit: {
          colorClass: 'accent--yellow',
          icon: '/assets/icons/freizeit.png',
        },
        'Aus- & Weiterbildung': {
          colorClass: 'accent--teal',
          icon: '/assets/icons/beruf.png',
        },
        'Ausbildung & Weiterbildung': {
          colorClass: 'accent--teal',
          icon: '/assets/icons/beruf.png',
        },
        'Kita- & Schulfinder': {
          colorClass: 'accent--orange',
          icon: '/assets/icons/kita.png',
        },
      };

      const filters = getStructuredFilters(this.ctAngebote);
      if (!filters || !filters.length || !filters[0].options) return [];
      const parentFieldTypeId = filters[0].field_type_id;

      return filters[0].options.map((opt, idx) => {
        const parentCategoryName = opt.label || opt.value;
        const styles = categoryStyles[parentCategoryName] || {
          colorClass: palette[idx % palette.length],
          icon: icons[idx % icons.length],
        };

        return {
          title: parentCategoryName,
          colorClass: styles.colorClass,
          icon: styles.icon,
          parentFieldTypeId: parentFieldTypeId,
          parentCategoryName: parentCategoryName,
          subFieldTypeId: opt.field_type_id,
          items: (opt.options || []).map((sub) => ({
            label: sub.label || sub.value,
            fieldTypeId: opt.field_type_id,
          })),
        };
      });
    },
    activeAccentClass() {
      if (this.activeCategory && this.activeCategory.colorClass) {
        return this.activeCategory.colorClass;
      }
      return '';
    },
  },
  methods: {
    handleNavigate(target) {
      this.closeSheet();
      if (target === 'home') {
        if (this.route === '/') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.$router.push('/');
        }
        return;
      }

    },
    openSheet(panel) {
      this.activeCategory = null;
      this.openPanel = this.openPanel === panel ? null : panel;
    },
    closeSheet() {
      this.openPanel = null;
      this.activeCategory = null;
    },
    navigateToCategory(item, category) {
      // Build filter array with both parent and sub-filter
      const filterArray = [
        [category.parentFieldTypeId, [category.parentCategoryName]],
        [item.fieldTypeId, [item.label]]
      ];
      const filtersParam = encodeURIComponent(JSON.stringify(filterArray));
      this.$router.push(`/angebote?filters=${filtersParam}`);
      this.closeSheet();
    },
    navigateTo(to) {
      this.$router.push(to);
      this.closeSheet();
    },
    navigateMore(link) {
      if (link.type === 'action' && typeof link.onClick === 'function') {
        link.onClick();
        return;
      }
      if (link.external) {
        window.open(link.external, '_blank', 'noopener');
        this.closeSheet();
        return;
      }
      if (link.to) {
        this.$router.push(link.to);
      }
      this.closeSheet();
    },
    fetchContentTypes() {
      const resource = new Resource('contenttypes');
      resource.get(1).then((res) => {
        this.ctOrte = res.data;
      }).catch(() => {
        this.ctOrte = null;
      });
      resource.get(2).then((res) => {
        this.ctAngebote = res.data;
      }).catch(() => {
        this.ctAngebote = null;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.mobile-nav {
  position: relative;
}

.nav {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  gap: 4px;
  padding: 0 6px;

  .nav-link {
    border: none;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px 4px;
    color: #6b6e76;
    font-size: 12px;
    border-radius: 14px;
    transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;

    span.material-icons-outlined {
      color: #9aa0ab;
      font-size: 22px;
    }

    &.active,
    &.expanded {
      color: #ffffff;
      background: $primary;
      box-shadow: 0 6px 18px rgba(0, 69, 140, 0.2);

      span.material-icons-outlined {
        color: #ffffff;
      }
    }
  }
}

.sheet {
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
  background: $white-color;
  box-shadow: 0 -10px 28px rgba(0, 0, 0, 0.16);
  border-radius: 18px 18px 0 0;
  padding: 14px 14px 20px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 10000;
}

.sheet__header {
  display: grid;
  grid-template-columns: 44px 1fr auto;
  align-items: center;
  padding-left: 14px;
  padding-right: 14px;

  .sheet__title {
    text-align: center;
    font-weight: 700;
    color: $text-color;
    font-size: 16px;
  }

  .sheet__close {
    justify-self: end;
    margin-right: -20px;
  }

  button {
    border: none;
    background: transparent;
    padding: 6px;
    border-radius: 8px;
    color: inherit;

    &:focus-visible {
      outline: 2px solid $primary;
      outline-offset: 2px;
    }
  }
}

.sheet__body {
  overflow-y: auto;
  padding-bottom: 6px;
}

.sheet-list {
  display: flex;
  flex-direction: column;
  gap: 6px;

  &__item {
    width: 100%;
    text-align: left;
    border: 1px solid #e6e9f2;
    background: #ffffff;
    border-radius: 14px;
    padding: 12px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $text-color;
    font-size: 15px;
    transition: background 0.2s ease, box-shadow 0.2s ease;

    &:focus-visible,
    &:hover {
      background: #f7f8fb;
      box-shadow: 0 8px 14px rgba(0, 0, 0, 0.08);
    }
  }

  &__item--plain {
    font-weight: 600;
    justify-content: flex-start;
  }

  &__meta {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }

  .sheet-icon {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }

  .sheet-list__title {
    font-weight: 800;
    font-size: 16px;
  }

  .arrow {
    color: $text-light;
  }
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;

  &--magenta {
    background: #cb0b5f;
  }

  &--yellow {
    background: #f3c200;
  }

  &--teal {
    background: #007a83;
  }

  &--orange {
    background: #f08a28;
  }
}

.accent--magenta {
  color: #cb0b5f;
}

.accent--yellow {
  color: #e2aa00;
}

.accent--teal {
  color: #007a83;
}

.accent--orange {
  color: #f08a28;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>
